module.exports = __webpack_public_path__ + "img/procedure_type.d664d138.svg";